import { useState } from "react";
import "./FAQ.scss";
import ButtonRounded from "../../components/shared/ButtonRounded";

import QuestionLeftImg from "../../assets/images/faq/question-left.png";
import QuestionRightImg from "../../assets/images/faq/question-right.png";

const faqItems = [
	{
		question: "What is Vernus AI?",
		answer: "Vernus AI is an advanced platform that leverages AI to provide market predictions and insights, particularly for cryptocurrency markets. It uses cutting-edge algorithms and real-time data to assist users in making informed investment decisions.",
	},
	{
		question: "Who can use Vernus AI?",
		answer: "Vernus AI is designed for a wide range of users, including cryptocurrency investors, traders, and financial analysts. Whether you're a beginner or an experienced professional, Vernus AI provides tools and insights to support your investment strategies.",
	},
	{
		question: "How accurate is the Market Predictor AI?",
		answer: "While Vernus AI’s Market Predictor uses advanced algorithms and real-time data analysis, crypto markets are highly volatile. The AI provides insights and trends based on historical and current data, but it should not be considered financial advice. Users are encouraged to conduct their own research before making investment decisions.",
	},
	{
		question: "When will Vernus AI launch?",
		answer: "The launch date for Vernus AI has not been specified in the provided information. For the most accurate and up-to-date information, please check the official Vernus AI website or follow their announcements on social media.",
	},
];

export default function FAQ() {
	return (
		<div className="faq">
			<div className="faq-content-wrapper content-wrapper-lg">
				<img
					src={QuestionLeftImg}
					alt="Question Left"
					className="question-left decoration"
					data-aos="fade-left"
				/>
				<img
					src={QuestionRightImg}
					alt="Question Right"
					className="question-right decoration"
					data-aos="fade-right"
				/>
				
				<div className="faq-content">
					<h3 className="faq-title" data-aos="fade-up">
						<span className="title-txt">
							Frequently Asked Questions
						</span>
					</h3>

					<p className="faq-desc" data-aos="fade-up" data-aos-delay="100">
						Quick answers to common questions.
					</p>

					<div className="faq-items">
						{faqItems.map((item, index) => (
							<FAQItem
								key={index}
								question={item.question}
								answer={item.answer}
							/>
						))}
					</div>

					<div className="contact-us-card">
						<div className="contact-us-card-content">
							<h4 className="contact-us-card-title">
								Do You Have Other Questions?
							</h4>
							<p className="contact-us-card-desc">
								We are available to answer you
							</p>
						</div>

						<div className="contact-us-card-btn">
							<ButtonRounded className="contact-us-btn">
								Contact Us
							</ButtonRounded>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

function FAQItem({ question, answer }) {
	const [isOpen, setIsOpen] = useState(false);

	const toggleOpen = () => {
		setIsOpen(!isOpen);
	};

	return (
		<div className={`faq-item ${isOpen ? "open" : ""}`}>
			<div className="faq-question" onClick={toggleOpen}>
				<div className="faq-question-content">
					<div className="faq-question-text">{question}</div>
					<div className="faq-toggle-icon">{isOpen ? "-" : "+"}</div>
				</div>
			</div>
			<div className={`faq-answer ${isOpen ? "open" : ""}`}>
				<p>{answer}</p>
			</div>
		</div>
	);
}
